import { ComponentRef, Directive, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FilesListStateService } from '@modules/files/services/files-list-state.service';
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';
import type { PopoverPlacement } from '@frontendlib/components/features/popover/types/placement';
import type { PopoverTrigger } from '@frontendlib/components/features/popover/types/trigger';
import { startWith, takeUntil } from 'rxjs/operators';
import { FilesListContextMenuComponent } from '../components/files-list-context-menu/files-list-context-menu.component';

@Directive({
  selector: '[appFilesListContextMenu]',
  standalone: false,
})
export class FilesListContextMenuDirective extends ContextMenuDirective implements OnInit, OnDestroy {
  @Input() appFilesListContextMenuWithAdvancedSearch: boolean;
  @Input() appFilesListContextMenuWithScore: boolean;
  @Input() stchPopoverTrigger: PopoverTrigger = 'click';
  @Input() stchPopoverPlacement: PopoverPlacement = 'bottomLeft';

  private readonly filesListStateService = inject(FilesListStateService);

  public registerInstance(componentRef: ComponentRef<FilesListContextMenuComponent>) {
    componentRef.instance.state = this.filesListStateService.state;
    componentRef.instance.withAdvancedSearch = this.appFilesListContextMenuWithAdvancedSearch;
    componentRef.instance.withScore = this.appFilesListContextMenuWithScore;
  }

  registerComponent() {
    return FilesListContextMenuComponent;
  }

  public override ngOnInit() {
    super.ngOnInit();

    this.filesListStateService.state
      .changes()
      .pipe(startWith(null), takeUntil(this.alive))
      .subscribe(() => {
        this.isDefaultStateObservable?.next(this.filesListStateService.state.isDefault());
      });

    if (!this.isDefaultStateObservable) {
      return;
    }

    this.isDefaultStateObservable.pipe(takeUntil(this.alive)).subscribe((isDefault) => {
      if (isDefault && !this.filesListStateService.state.isDefault()) {
        this.filesListStateService.state.resetToDefault();
      }
    });
  }
}
